import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import rgba from "assets/theme/functions/rgba";

const { black, dark, primary } = colors;
const { borderWidth } = borders;

function TextFeedbackAnalyticsCard({ item }) {
  const commonThemes = Array.isArray(item?.commonThemes) ? item.commonThemes : [];
  const recentResponses = Array.isArray(item?.recentResponses) ? item.recentResponses : [];

  return (
    <VuiBox
      p={2}
      borderRadius="18px"
      sx={{
        height: "100%",
        background: rgba(black.main, 0.025),
        border: `${borderWidth[1]} solid ${rgba(black.main, 0.08)}`,
      }}
    >
      <VuiBox display="flex" justifyContent="space-between" alignItems="flex-start" gap={2} mb={0}>
        <VuiBox>
          <VuiTypography variant="button" color="dark" fontWeight="bold">
            {item?.question || "Written Feedback"}
          </VuiTypography>

          {/* <VuiTypography
            display="block"
            variant="caption"
            color="dark"
            fontWeight="regular"
            sx={{ opacity: 0.7, mt: 0.3 }}
          >
            Common themes and recent responses
          </VuiTypography> */}
        </VuiBox>

        <VuiBox textAlign="right">
          <VuiTypography variant="button" color="dark" fontWeight="bold">
            {item?.responses || 0}
          </VuiTypography>

          <VuiTypography
            display="block"
            variant="caption"
            color="dark"
            fontWeight="regular"
            sx={{ opacity: 0.7 }}
          >
            responses
          </VuiTypography>
        </VuiBox>
      </VuiBox>

      {/* <VuiBox mb={1}>
        <VuiTypography variant="caption" color="dark" fontWeight="bold">
          Common Themes
        </VuiTypography>

        <VuiBox display="flex" gap={1} flexWrap="wrap" mt={1}>
          {commonThemes.length ? (
            commonThemes.map((theme) => (
              <VuiBox
                key={theme.label}
                px={1.2}
                py={0}
                borderRadius="12px"
                sx={{
                  background: rgba(primary.main, 0.08),
                  border: `${borderWidth[1]} solid ${rgba(primary.main, 0.16)}`,
                }}
              >
                <VuiTypography variant="caption" color="dark" fontWeight="medium">
                  {theme.label}
                </VuiTypography>

                <VuiTypography variant="caption" color="dark" fontWeight="bold" sx={{ ml: 0.6 }}>
                  {theme.mentions}
                </VuiTypography>
              </VuiBox>
            ))
          ) : (
            <VuiTypography variant="caption" color="dark" fontWeight="regular">
              No common themes available.
            </VuiTypography>
          )}
        </VuiBox>
      </VuiBox> */}

      <VuiBox>
        <VuiTypography variant="caption" color="dark" fontWeight="bold">
          Recent Responses
        </VuiTypography>

        <VuiBox display="flex" flexDirection="column" gap={1} mt={1}>
          {recentResponses.length ? (
            recentResponses.map((response, index) => (
              <VuiBox
                key={index}
                p={1.2}
                borderRadius="12px"
                sx={{
                  background: rgba(black.main, 0.025),
                  border: `${borderWidth[1]} solid ${rgba(black.main, 0.07)}`,
                }}
              >
                <VuiTypography variant="caption" color="dark" fontWeight="regular">
                  “{response}”
                </VuiTypography>
              </VuiBox>
            ))
          ) : (
            <VuiTypography variant="caption" color="dark" fontWeight="regular">
              No written responses yet.
            </VuiTypography>
          )}
        </VuiBox>
      </VuiBox>
    </VuiBox>
  );
}

export default TextFeedbackAnalyticsCard;
